// src/components/FormSections/FormSectionFactura.js

import React, { useState, useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { Button, Row, Col } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikSelect from "../Common/Formik/FormikSelect"
import { listaUsoCFDI } from "../../constants/cfdiUsos"

// #region selectors
import {
  useContribuyentesOptions,
  useAuthIdPersonaAuthenticated,
} from "store/selectors"
// #endregion

// #region actions
import { getContribuyentesOptions } from "../../store/actions"
// #endregion
const FormSectionFactura = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
  resetForm,
}) => {
  //
  // #region Init
  const optionsCampus = []
  const optionsProgramasAcademicos = []
  const optionsPlanesEstudio = []
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States
  const [usosCFDI, setUsosCFDI] = useState([])
  // #endregion

  // #region const-selectors
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const optionsContribuyentes = useContribuyentesOptions()
  // #endregion

  // #region useEffect
  useEffect(() => {
    //console.log("Montando el componente: FormSectionFactura")
    //console.log("optionsContribuyentes.length: ", optionsContribuyentes.length)
    if (optionsContribuyentes.length === 0) {
      //console.log("dispatching : getContribuyentesOptions")
      dispatch(
        getContribuyentesOptions({
          nombreSolicitud: "optionscontribuyentes",
        })
      )
    }
  }, [optionsContribuyentes, dispatch])

  // useEffect(() => {
  //   if (optionsContribuyentes.length > 0) {
  //     // console.log(
  //     //   "optionsContribuyentes.length: ",
  //     //   optionsContribuyentes.length
  //     // )
  //     //console.log("optionsContribuyentes: ", optionsContribuyentes)
  //   }
  // }, [optionsContribuyentes])

  useEffect(() => {
    const id_Contribuyente = formik.values.id_Contribuyente
    //console.log("id_Contribuyente: ", id_Contribuyente)
    if (id_Contribuyente > 0) {
      const oContribuyente = optionsContribuyentes.find(
        oContribuyente => oContribuyente.value === id_Contribuyente
      )

      //console.log("oContribuyente: ", oContribuyente)
      // 13 Personas Físicas
      if (oContribuyente?.label?.length === 13) {
        setUsosCFDI(
          convierteUsosCfdi_Options(
            listaUsoCFDI.filter(item => item.Aplica_Personas_Fisicas === true)
          )
        )
      } // 12 Personas morales
      else {
        setUsosCFDI(
          convierteUsosCfdi_Options(
            listaUsoCFDI.filter(item => item.Aplica_Personas_Morales === true)
          )
        )
      }
    }
  }, [formik.values.id_Contribuyente, optionsContribuyentes])

  // #endregion

  // #region functions

  const convierteUsosCfdi_Options = listaUsoCFDI => {
    return listaUsoCFDI.map(option => {
      return {
        value: option.id_Cfdi_Uso,
        label: option.Clave + " - " + option.Descripcion,
      }
    })
  }

  // #endregion

  // #region useMemo
  //  // #endregion

  return (
    <React.Fragment>
      <>
        {/* Sección Factura-Alumno */}
        <h5 className="mb-4">Fcturación</h5>
        {/* CheckBox Factura */}
        <Row>
          <Col md={12}>
            <label>
              <input
                type="checkbox"
                name="requiereFactura"
                value="0"
                checked={formik.values.requiereFactura}
                onChange={() =>
                  formik.setFieldValue(
                    "requiereFactura",
                    !formik.values.requiereFactura
                  )
                }
                //disabled={!formik.values.requiereFactura}
              />{" "}
              Requiere Factura
            </label>
          </Col>
        </Row>
        {/* RFC */}
        <Row>
          {/* RFC */}
          <Col md={4}>
            <div className="mb-3">
              <FormikSelect
                label="* RFC"
                name="id_Contribuyente"
                options={optionsContribuyentes || []}
                formik={formik}
                placeholder="Selecciona Contribuyente"
                valuePlaceHolder={-1}
                disabled={!formik.values.requiereFactura}
              />
            </div>
          </Col>
          {/* Uso CFDI */}
          <Col md={4}>
            <div className="mb-3">
              <FormikSelect
                label="* Uso CFDI"
                name="usoCfdi"
                options={usosCFDI || []}
                formik={formik}
                placeholder="Selecciona uso CFDI"
                valuePlaceHolder={-1}
                disabled={!formik.values.requiereFactura}
              />
            </div>
          </Col>
          {/* Plan Estudio */}
          <Col md={4}>
            <div className="mb-3">
              <label>
                <input
                  type="checkbox"
                  name="soloColegiatura"
                  value="0"
                  checked={formik.values.soloColegiatura}
                  onChange={() =>
                    formik.setFieldValue(
                      "soloColegiatura",
                      !formik.values.soloColegiatura
                    )
                  }
                  disabled={!formik.values.requiereFactura}
                />{" "}
                Solo Colegiatura
              </label>
            </div>
          </Col>
        </Row>
        {/* CC Email Observaciones */}
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <FormikInput
                label="* CC Email"
                name="ccEmails"
                placeholder="Emails1, Email2, Email3"
                formik={formik}
                onChange={handleLowerCaseChange}
                disabled={!formik.values.requiereFactura}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-3">
              <FormikInput
                label="Observaciones"
                name="facturaObservaciones"
                placeholder=""
                formik={formik}
                onChange={handleUpperCaseChange}
                disabled={!formik.values.requiereFactura}
              />
            </div>
          </Col>
        </Row>
      </>
    </React.Fragment>
  )
}

export default FormSectionFactura
